import { combineReducers } from 'redux';

import game from './game/reducer';
import modals from './modals/reducer';

export default combineReducers({
  game,
  modals,
});

